import axios from 'axios';
import Cookies from 'js-cookie';
import config from '../../config';

// Crear instancia de Axios con baseURL y JWT
const api = axios.create({
    baseURL: config.baseUrl,
});

api.interceptors.request.use(
    cfg => {
        const token = Cookies.get('token');
        if (token) cfg.headers['Authorization'] = `Bearer ${token}`;
        return cfg;
    },
    error => Promise.reject(error)
);

// Endpoint base para proveedores
const ENDPOINT = '/api/entregas/proveedores';

/**
 * Obtener todos los proveedores
 */
export const getProveedores = async () => {
    try {
        const response = await api.get(ENDPOINT);

        return {
            status: response.status,
            data: response.data.data || [],
        };
    } catch (error) {
        console.error('Error fetching proveedores:', error);
        return {
            status: error.response?.status || 500,
            message: error.response?.data?.message || 'Error fetching proveedores',
        };
    }
};

/**
 * Crear nuevo proveedor
 */
export const createProveedor = async (payload) => {
    try {
        const response = await api.post(ENDPOINT, payload);
        return {
            status: response.status,
            data: response.data.data || null,
            message: response.data.message,
        };
    } catch (error) {
        console.error('Error creating proveedor:', error);
        return {
            status: error.response?.status || 500,
            message: error.response?.data?.message || 'Error al crear proveedor',
        };
    }
};


/**
 * Actualizar proveedor existente
 */
export const updateProveedor = async (oid, payload) => {
    try {
        const response = await api.put(`${ENDPOINT}/${oid}`, payload);
        return {
            status: response.status,
            message: response.data.message || 'Proveedor actualizado correctamente',
        };
    } catch (error) {
        console.error('Error updating proveedor:', error);
        return {
            status: error.response?.status || 500,
            message: error.response?.data?.message || 'Error updating proveedor',
        };
    }
};

/**
 * Eliminar proveedor por oid
 */
export const deleteProveedor = async (oid) => {
    try {
        const response = await api.delete(`${ENDPOINT}/${oid}`);
        return {
            status: response.status,
            message: response.data.message || 'Proveedor eliminado correctamente',
        };
    } catch (error) {
        console.error('Error deleting proveedor:', error);
        return {
            status: error.response?.status || 500,
            message: error.response?.data?.message || 'Error deleting proveedor',
        };
    }
};
